import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography } from '@mui/material';

// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
import useLocales from '../../hooks/useLocales';
// components
import { MIconButton } from '../../components/@material-extend';
import MyAvatar from '../../components/MyAvatar';
import MenuPopover from '../../components/MenuPopover';
import PasswordModal from './PasswordModal';

// ----------------------------------------------------------------------
const AvatarStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '& >p': {
    marginLeft: '10px',
    font: 'normal normal medium 17px/20px Noto Sans CJK SC',
    color: '#383E80',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
      fontSize: 14,
      maxWidth: 100
    }
  }
}));

// const MENU_OPTIONS = [
//   {
//     label: 'Home',
//     icon: homeFill,
//     linkTo: '/'
//   },
//   {
//     label: 'Profile',
//     icon: personFill,
//     linkTo: PATH_DASHBOARD.user.editById
//   },
//   {
//     label: 'Settings',
//     icon: settings2Fill,
//     linkTo: PATH_DASHBOARD.user.account
//   }
// ];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const isMountedRef = useIsMountedRef();
  const { trans } = useLocales();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // 修改密碼彈窗
  const [PassModal, setPassModal] = useState(false);
  const PasswordModalOpen = () => setPassModal(true);
  const PasswordModalClose = () => setPassModal(false);

  const handleLogout = async () => {
    try {
      await logout?.();
      if (isMountedRef.current) {
        navigate('/');
        handleClose();
      }
      enqueueSnackbar(trans('ModifySecret.success_to_logout'), { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(trans('ModifySecret.unable_to_logout'), { variant: 'error' });
    }
  };

  return (
    <>
      <AvatarStyle onClick={handleOpen}>
        <MIconButton
          ref={anchorRef}
          sx={{
            padding: 0,
            width: 37,
            height: 37,
            ...(open && {
              '&:before': {
                zIndex: 1,
                content: "''",
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                position: 'absolute',
                bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
              }
            })
          }}
        >
          <MyAvatar />
        </MIconButton>
      </AvatarStyle>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {user?.full_name}
          </Typography>
          {/* <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography> */}
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))} */}
        <MenuItem
          onClick={() => {
            PasswordModalOpen();
          }}
          sx={{ typography: 'body2', py: 1, px: 2.5 }}
        >
          <Box
            component={Icon}
            icon={settings2Fill}
            sx={{
              mr: 2,
              width: 24,
              height: 24
            }}
          />
          {trans('ModifySecret.update_password')}
        </MenuItem>
        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button fullWidth color="inherit" variant="outlined" onClick={handleLogout}>
            {trans('ModifySecret.logout')}
          </Button>
        </Box>
      </MenuPopover>
      <PasswordModal PassModal={PassModal} PasswordModalClose={PasswordModalClose} />
    </>
  );
}
